<template>
  <AdminLeaveManagement v-if="isAdmin" />
  <EmployeeLeaveManagement v-else />
</template>

<script>
import AdminLeaveManagement from "./AdminLeaveManagement.vue";
import EmployeeLeaveManagement from "./EmployeeLeaveManagement.vue";

export default {
  components: {
    AdminLeaveManagement,
    EmployeeLeaveManagement,
  },
  data() {
    const user = this.$store.state.auth.user;
    return {
      isAdmin: user && user.role === "admin",
    };
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/LeaveManagement/index.vue